import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const approvalStatusClassNames = {
  approved: 'tw-text-green-800 tw-bg-green-025',
  approvedWithConditions: 'tw-text-green-800 tw-bg-green-025',
  notSubmitted: 'tw-text-cyan-800 tw-bg-cyan-025',
  pending: 'tw-text-amber-800 tw-bg-amber-025',
  rejected: 'tw-text-red-800 tw-bg-red-025',
};

export default function ApprovalStatusIndicator({ status }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const statusClassNames = approvalStatusClassNames[status];

  if (!statusClassNames) return null;

  return (
    <div
      className={classNames(
        'tw-truncate tw-rounded-lg tw-border-0 tw-px-2 tw-py-1 tw-text-s tw-font-medium tw-tracking-wide',
        statusClassNames,
      )}
    >
      {i18nTShared(status === 'approvedWithConditions' ? 'approved' : status)}
    </div>
  );
}

ApprovalStatusIndicator.propTypes = {
  status: PropTypes.oneOf(Object.keys(approvalStatusClassNames)),
};
